import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type ProgressBarVariant = 'block' | 'pill';

export interface ProgressBarSegment {
  kind: 'passed' | 'failed' | 'skipped' | 'blocked' | 'not-run' | 'in-progress' | 'open';
  width: number;
}

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  readonly passed = input(0);
  readonly failed = input(0);
  readonly inProgress = input(0);
  readonly skipped = input(0);
  readonly blocked = input(0);
  readonly notRun = input(0);
  readonly open = input(0);
  readonly total = input<number | null>(null);
  readonly ariaLabel = input<string | null>(null);
  readonly variant = input<ProgressBarVariant>('block');

  readonly segments = computed<ProgressBarSegment[]>(() => {
    const counts: [ProgressBarSegment['kind'], number][] = [
      ['passed', this.passed()],
      ['failed', this.failed()],
      ['skipped', this.skipped()],
      ['blocked', this.blocked()],
      ['not-run', this.notRun()],
      ['in-progress', this.inProgress()],
      ['open', this.open()],
    ];
    const total = this.total() ?? counts.reduce((sum, [, count]) => sum + count, 0);
    const segments = counts.map(([kind, count]) => ({ kind, width: total === 0 ? 0 : (count / total) * 100 }));
    // Die Pille behaelt leere Segmente, damit die Breite beim ersten Ergebnis von 0 aus animiert.
    return this.variant() === 'pill' ? segments : segments.filter((segment) => segment.width > 0);
  });
}
